import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { TranslatorConverter } from "src/TranslatorConverter";
import { IFileDownloader } from "src/uicomponents/components/fileSelector/fileSelector-viewModel";
import { ServerSideDataLoader, PaginationInfo, Enum, IEnumTranslator } from "uicomponents";
import  { PayableReceivablesListView } from "./payableReceivablesList-view"
import { translate } from "src/common/utilities";

export class PayableReceivablesListViewModel extends WindowViewModel{
    public getTitle(): string {
        return translate("payableReceivablesList-viewModel.receiptsAndPaymentsList",{});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.rows = ObservableArray.create<row>();
        this.methodEnumProvider = new methodTypeEnumProvider();
        this.transactionTypeEnumProvider = new TransactionTypeEnumProvider();
        this.statusEnumProvider = new statusEnumProvider();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),30);
        this.refresh();

    }
    GetDefaultView(): View <ViewModel> {
        return new PayableReceivablesListView();
    }
    public getTypeId(): string {
        return "VM-849227D4-2A9E-4B6D-9BFD-A6444FD37999"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set methodEnumProvider(v: methodTypeEnumProvider) { this._typeEnumProvider = v; } public get methodEnumProvider(): methodTypeEnumProvider { return this._typeEnumProvider;} private _typeEnumProvider: methodTypeEnumProvider;
    public set transactionTypeEnumProvider(v: TransactionTypeEnumProvider) { this._transactionTypeEnumProvider = v; } public get transactionTypeEnumProvider(): TransactionTypeEnumProvider { return this._transactionTypeEnumProvider;} private _transactionTypeEnumProvider: TransactionTypeEnumProvider;
    public set rows(v: ObservableArray<row>) { this._rows = v; } public get rows(): ObservableArray<row> { return this._rows;} private _rows: ObservableArray<row>;
    public set statusEnumProvider(v: statusEnumProvider) { this._statusEnumProvider = v; } public get statusEnumProvider(): statusEnumProvider { return this._statusEnumProvider;} private _statusEnumProvider: statusEnumProvider;
    
    
    refresh() {
        this.loader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ArapServices/GetAllPayableReceivables',{
                FurtherQueryInfo:filteringInformation
            });
            let downloader = new Downloader();
            this.rows.update(...result.PayableReceivables.map((x,i)=>{
                let r = new row(this);
                r.index = i+1;
                r.id = x.Id;
                r.amount = x.Amount;
                r.arapNo = x.ArapNo;
                r.accountingCode = x.AccountingCode;
                r.comment = x.Comment;
                r.time = moment.utc(x.Time);
                r.method = x.Method;
                r.type = x.Type;
                r.status = x.Status;
                r.partyName = x.PartyName;
                r.requestAttachments.update(...x.Attachments.map(q=>{
                    let a = new attachment(r);
                    a.id = q.Id;
                    a.name = q.Name;
                    a.downloader = downloader;
                    return a;
                }))
                r.hasAttachments = r.requestAttachments.length>0;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);

        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }

}
class Downloader implements IFileDownloader{
    async download(fileId: string, filename: string): Promise<{ name: string; content: string; }> {
        let result = await ServerConnection.callServer('/Complex/ArapServices/GetTransactionAttachmentFileContent',{
            FileId : fileId
        });
        return {
            name : filename,
            content : result.FileContent
        };
    }

} 
export class row extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.showDetail = false;
        this.requestAttachments = ObservableArray.create<attachment>();
    }
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set accountingCode(v: string) { this._accountingCode = v; } public get accountingCode(): string { return this._accountingCode;} private _accountingCode: string;
    public set arapNo(v: string) { this._arapNo = v; } public get arapNo(): string { return this._arapNo;} private _arapNo: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set method(v: number) { this._method = v; } public get method(): number { return this._method;} private _method: number;
    public set type(v: number) { this._type = v; } public get type(): number { return this._type;} private _type: number;
    public set status(v: number) { this._status = v; } public get status(): number { return this._status;} private _status: number;
    public set showDetail(v: boolean) { this._showDetail = v; } public get showDetail(): boolean { return this._showDetail;} private _showDetail: boolean;
    public set requestAttachments(v: ObservableArray<attachment>) { this._requestAttachments = v; } public get requestAttachments(): ObservableArray<attachment> { return this._requestAttachments;} private _requestAttachments: ObservableArray<attachment>;
    public set hasAttachments(v: boolean) { this._hasAttachments = v; } public get hasAttachments(): boolean { return this._hasAttachments;} private _hasAttachments: boolean;
    public set partyName(v: string) { this._partyName = v; } public get partyName(): string { return this._partyName;} private _partyName: string;
    

    toggleDetail(){
        this.showDetail = !this.showDetail;
    }
}
export class attachment extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set downloader(v: IFileDownloader) { this._downloader = v; } public get downloader(): IFileDownloader { return this._downloader;} private _downloader: IFileDownloader;
    
}
export class methodTypeEnumProvider extends Enum implements IEnumTranslator{

    constructor() {
        super();
        this.translator = this;
        this.values = [1,2,3,4,5,7,8,9,10,12,13];        
    }
    GetString(value: any) {
        return new TranslatorConverter().methodConverter(value);
    }
}
export class TransactionTypeEnumProvider extends Enum implements IEnumTranslator{

    constructor() {
        super();
        this.translator = this;
        this.values = [1,2];        
    }
    GetString(value: any) {
        return new TranslatorConverter().payableReceivableConverter(value);
    }
}

export class statusEnumProvider extends Enum implements IEnumTranslator{

    constructor() {
        super();
        this.translator = this;
        this.values = [1,2,3];        
    }
    GetString(value: any) {
        return new TranslatorConverter().arapTransactionStatusConverter(value);
    }
}